import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'sl-form-field-error-control',
    templateUrl: './form-field-error-control.component.html',
    styleUrls: ['./form-field-error-control.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldErrorControlComponent {
    @Input() control: AbstractControl;
}
